import { initializeCodeCopy } from './src/browser/code-copy'
import {
  initializeOriginalImageIndicators,
  updateOriginalImageIndicatorsForRoute,
} from './src/browser/original-image-indicators'

export const onClientEntry = () => {
  initializeCodeCopy()
  initializeOriginalImageIndicators()
}

export const onRouteUpdate = () => {
  updateOriginalImageIndicatorsForRoute()
}
